export type { FC } from "react";

export enum ESearchTypes {
  STATUS,
  TAG,
  SHARED,
  CHANNEL,
}

export interface Props {
  isExpanded?: boolean;
  onChange: (
    value: string,
    statusId: string | null,
    tagId: string | null,
    entityId: string | null,
    kind: number | null
  ) => void;
}
